/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MetadataItem,
    MetadataItemFromJSON,
    MetadataItemFromJSONTyped,
    MetadataItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface RegisterUploadMetadataEndpointRequest
 */
export interface RegisterUploadMetadataEndpointRequest {
    /**
     * 
     * @type {Array<MetadataItem>}
     * @memberof RegisterUploadMetadataEndpointRequest
     */
    items: Array<MetadataItem>;
}

export function RegisterUploadMetadataEndpointRequestFromJSON(json: any): RegisterUploadMetadataEndpointRequest {
    return RegisterUploadMetadataEndpointRequestFromJSONTyped(json, false);
}

export function RegisterUploadMetadataEndpointRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegisterUploadMetadataEndpointRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(MetadataItemFromJSON)),
    };
}

export function RegisterUploadMetadataEndpointRequestToJSON(value?: RegisterUploadMetadataEndpointRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(MetadataItemToJSON)),
    };
}


